import React, { useEffect, useState } from "react";
import { FILTER__FORM_FIELDS_GLOBAL, getDisplayList, hardcodeDropdown, ignoreFilterItem } from "./constants";
import PaymentCollectionHeader from "../studentFinancials/paymentCollection/PaymentCollectionHeader";
import SearchSchoolForm from "./SearchSchoolForm";
import { getFilterCount } from "../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import ModuleCards from "./ModuleCards";
import { getDropdowns } from "./constants";
import SchoolList from "./schoolListing/SchoolList";
import { endpoint } from '../../../manage/common/constant'
import { fetchAllPostPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";
import { updateRequest } from "../../edpOps/constant/common";
import ALoader from "../../common/a-loader";

const SearchSchools = ({ getAll = false }) => {

    const [isListVisible, setListVisible] = useState(false);
    const [globalFilter, setGlobalFilter] = useState({ ...FILTER__FORM_FIELDS_GLOBAL });
    const [isLoading, setIsLoading] = useState(false);
    const [filterType, setFilterType] = useState('single');
    const [selectedFilter, setSelectedFilter] = useState('SINGLE');
    const [dropdowns, setDropdowns] = useState({});
    const [filterCount, setFilterCount] = useState(getFilterCount({ ...globalFilter }, ignoreFilterItem));
    const [rows, setRows] = useState([])
    const [currentPage, setCurrentPage] = useState(0);
    const [rowCount, setRowCount] = useState(0);

    // const [filterCount, setFilterCount] = useState(getFilterCount({ ...globalFilter }, ["schoolType", "searchValue"]));

    const fetchDropdownData = async (getall = false) => {
        try {
            !!getall!=true&&setIsLoading(true);
            const res = await getDropdowns();
            setDropdowns(res);
            if (getAll)
                return res;
        } catch (err) {
            console.log(err);
        } finally {
            !!getall!=true&&setIsLoading(false);
        }
    }
    useEffect(() => {
        if (!!getAll) {
            fetchData()
        }
    }, [])
    const fetchData = async () => {
        try {
            setIsLoading(true)
            const d = await fetchDropdownData(getAll)
            await searchHandler({ mappedBranchIds: d?.allBusinessArea }, 0, d)
        }
        catch (error) {
            console.log(error)
        }
        finally {
            setIsLoading(false)
        }
    }

    const searchHandler = async (reqObj = {}, page = 0, drop = dropdowns,loader=false) => {
        try {
            !!getAll != true && setIsLoading(true);
            loader&&setIsLoading(true)
            setListVisible(true);
            const req = updateRequest(reqObj)
            const res = await fetchAllPostPromisedData(`${endpoint.schoolMaster.search}?offset=${page}`,
                { ...req, mappedBranchIds: (req?.mappedBranchIds ?? []).length > 0 ? req?.mappedBranchIds : (dropdowns?.allBusinessArea ?? []).map(item => item?.value) })
            console.log('res', res)
            if (res?.code == 200) {
                const dispData = getDisplayList(drop, res?.data.schoolMasterList)
                setRows(dispData)
                setRowCount(res?.data.totalRecords);
            }
        } catch (err) {
            console.log(err);
        } finally {
            !!getAll != true && setIsLoading(false);
            loader&&setIsLoading(false)
        }
    };
    const onPageChange = (newPage) => {
        setCurrentPage(newPage);
        searchHandler({}, newPage,dropdowns,true);
    };

    useEffect(() => {
        !!getAll != true && fetchDropdownData(getAll);
    }, [])

    return (
        <>
            { isLoading ? <ALoader position='fixed' /> :(!isListVisible ? (
                <>
                    <div className="d-flex flex-column remove-container-top-space">
                        <div className="p-3 student-filer-container-printId">
                            <PaymentCollectionHeader text="Search schools" />
                            <SearchSchoolForm
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                                globalFilter={globalFilter}
                                setGlobalFilter={setGlobalFilter}
                                isListVisible={isListVisible}
                                setListVisible={setListVisible}
                                filterType={filterType}
                                setFilterType={setFilterType}
                                selectedFilter={selectedFilter}
                                setSelectedFilter={setSelectedFilter}
                                // setFilterCount={setFilterCount}
                                dropdownData={{ ...dropdowns, ...hardcodeDropdown }}
                                searchHandler={searchHandler}
                                setFilterCount={setFilterCount}

                            />
                        </div>
                    </div>
                    <ModuleCards
                        setListVisible={setListVisible}
                    />
                </>) : (
                <SchoolList
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    setListVisible={setListVisible}
                    dropdownData={{ ...dropdowns, ...hardcodeDropdown }}
                    searchHandler={searchHandler}
                    filterCount={filterCount}
                    setFilterCount={setFilterCount}
                    rows={rows}
                    rowCount={rowCount}
                    currentPage={currentPage}
                    onChangeHandler={onPageChange}
                    getAll={getAll}
                />
            ))}
        </>
    )
}

export default SearchSchools;